<template>
  <div class="usp">
    <div class="usp__media">
      <slot></slot>
    </div>
    <div class="usp__content">
      <component :is="textTag" class="usp__text" v-bind="tagProps">
        {{ text }}
      </component>
      <div v-if="additionalText" class="usp__additional-text">
        {{ additionalText }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      required: true
    },
    additionalText: {
      type: String,
      default: null
    },
    href: {
      type: String,
      default: '/se/sv/'
    },
    linkName: {
      type: String,
      default: ''
    }
  },
  computed: {
    textTag() {
      return this.href ? 'a' : 'p'
    },
    tagProps() {
      return this.href ? { href: this.href, 'aria-label': this.linkName } : {}
    }
  }
}
</script>

<style lang="scss">
.usp-list {
  @include container;
  position: relative;
  display: flex;
  flex-direction: column;
  margin-top: measure(full);
  margin-bottom: measure(full);

  @include media(small) {
    flex-direction: row;
    flex-wrap: wrap;
  }

  @include media(medium) {
    flex-wrap: nowrap;
  }
}

.usp-list > * {
  flex-shrink: 0;
  flex-basis: 100%;

  @include media(small) {
    flex-basis: 50%;
  }

  @include media(medium) {
    flex-basis: calc(100% / 3);
  }
}

.usp-list--2 > * {
  @include media(medium) {
    flex-basis: 50%;
  }
}

/* usp */

.usp {
  @include brand-border-after;
  position: relative;
  display: flex;
  align-items: flex-start;
  margin-bottom: measure(quarter);
  padding: measure(quarter) measure(half);
  color: color(text-inverted);
  background-color: color(gray-1);

  @include media(small) {
    &:first-child {
      border-right: 1px solid color(gray-3);

      &:after {
        right: -1px;
      }
    }
  }

  @include media(medium) {
    margin-bottom: 0;

    &:nth-child(1),
    &:nth-child(2) {
      border-right: 1px solid color(gray-3);

      &:after {
        margin-right: -1px;
      }
    }
  }
}

.usp-list--2 .usp {
  @include media(medium) {
    &:nth-child(2) {
      border-right: none;

      &:after {
        margin-right: 0;
      }
    }
  }
}

.usp__media {
  flex-shrink: 0;
  max-width: 3.75rem;
  max-height: 3.75rem;
  margin-right: measure(half);
}

.usp__image {
  max-width: 100%;
  max-height: 100%;
}

.usp__content {
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: measure(eighth);
}

.usp__text {
  @include body-bold;
}

a.usp__text {
  @include reset-link;
  color: color(text-inverted);
}

a.usp__text::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.usp__additional-text {
  @include body-smaller;
}

</style>
